module.exports = __webpack_public_path__ + "static/media/digital-signature.82bb063d.svg";